<template>
    <v-card>
        <v-data-table
            :footer-props="{itemsPerPageOptions:[1,5,10]}"
            :headers="headers"
            :items="items"
            :options.sync="options"
            :server-items-length="total"
            :loading="loading"
            show-expand
            class="elevation-0 dataTable pt-3"
        >
            <template
                v-slot:body.prepend="{ headers }"
            >
                <tr>
                    <td>
                        <v-text-field
                            v-model="hotelName"
                            label="Hotel..."
                            single-line
                            hide-details
                            v-on:keyup.enter="getData()">
                        </v-text-field>
                    </td>
                    <td>
                        <v-text-field
                            v-model="roomName"
                            label="Quarto..."
                            single-line
                            hide-details
                            v-on:keyup.enter="getData()">
                        </v-text-field>
                    </td>
                    <td>
                        <v-text-field
                            v-model="fareAmount"
                            prepend-inner-icon="mdi-currency-brl"
                            label="Valor..."
                            single-line
                            hide-details
                            v-on:keyup.enter="getData()">
                        </v-text-field>
                    </td>
                    <td><!--Expand item--></td>
                    <td class="text-center" >
                        <v-btn
                            class="mt-4"
                            depressed
                            color="primary"
                            width="80%"
                            v-on:click="getData()"
                        >
                            Buscar
                        </v-btn>
                        <v-btn
                            class="mt-4 mb-4"
                            depressed
                            color="#FBC02D"
                            width="80%"
                            v-on:click="getCleanFilter()"
                        >
                            Limpar
                        </v-btn>
                    </td>
                </tr>
            </template>
            <template v-slot:item.amount="{ item }">
                R$ {{ getFormattedAmount(item.amount) }}
            </template>
            <template v-slot:item.active="{ item }">
                <v-chip v-if="item.active === 1"
                        class="ma-2"
                        color="green"
                        text-color="white"
                >
                    {{ getActive(item) }}
                </v-chip>
                <v-chip v-if="item.active === 0 "
                        class="ma-2"
                        color="red"
                        text-color="white"
                >
                    {{ getActive(item) }}
                </v-chip>
            </template>
            <template v-slot:item.actions="{ item }">
                <v-container class="pa-0 ma-0 text-center">
                    <v-tooltip bottom>
                        <template #activator="{ on }">
                            <router-link :to="{name: 'editHotel', params: {id: item.room.hotel.id}}">
                                <v-icon
                                    v-on="on"
                                    small
                                    class="mr-2 edit"
                                >
                                    mdi-home-modern
                                </v-icon>
                            </router-link>
                        </template>
                        <span>Ir para hotel {{ item.room.hotel.name }}</span>
                    </v-tooltip>
                </v-container>
            </template>
            <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length">
                    <v-container class="max-content mb-2">
                        <h3 class="my-4">Detalhes do quarto</h3>
                        <v-row>
                            <v-col>
                                <p>Quantidade de hóspedes: </p>
                            </v-col>
                            <v-col>
                                {{ item.room.guests }}
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <p>Descrição:</p>
                            </v-col>
                            <v-col>
                                {{ item.room.description }}
                            </v-col>
                        </v-row>
                        <h3 class="my-4">Detalhes da tarifa</h3>
                        <v-row>
                            <v-col>
                                <p>Possui café da manhã?</p>
                            </v-col>
                            <v-col>
                                {{ formatBooleanField(item.breakfast) }}
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <p>É reembolsável?</p>
                            </v-col>
                            <v-col>
                                {{ formatBooleanField(item.refundable) }}
                            </v-col>
                        </v-row>
                        <v-row v-if="item.refundable">
                            <v-col>
                                <p>Dias antes do check-in que a tarifa é reembolsável:</p>
                            </v-col>
                            <v-col>
                                {{ item.days_before_checkin }}
                            </v-col>
                        </v-row>
                    </v-container>
                </td>
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
export default {
    name: "ListRelatedFares",

    data: () => ({
        items: [],
        loading: '',
        hotelName: '',
        roomName: '',
        fareAmount: '',
        options: {
            sortDesc: [true],
        },
        total: 0,
        headers: [
            {text: 'Hotel', value: 'room.hotel.name'},
            {text: 'Quarto', value: 'room.name'},
            {text: 'Valor da tarifa', value: 'amount', width: '15%'},
            {text: '', value: 'data-table-expand', width: '5%'},
            {text: 'Ações', value: 'actions', width: '15%', sortable: false},
        ],
    }),

    methods: {
        getFormattedAmount(amount) {
            amount = amount / 100;
            return parseFloat(amount).toFixed(2);
        },

        formatBooleanField(booleanValue) {
            if (booleanValue === 1) {
                return 'Sim';
            }
            return 'Não';
        },

        getData() {
            this.loading = true;
            const {sortBy, sortDesc, page, itemsPerPage} = this.options;
            const query = `sort=${sortBy}&sortDesc=${sortDesc}&page=${page}&perPage=${itemsPerPage}
                &hotelName=${this.hotelName}&roomName=${this.roomName}&fareAmount=${this.fareAmount}`;
            this.$router.push({
                query: {
                    sort: sortBy,
                    sortDesc: sortDesc,
                    page: page,
                    perPage: itemsPerPage,
                    hotelName: this.hotelName,
                    roomName: this.roomName,
                    fareAmount: this.fareAmount,
                }
            });

            axios.get(`/api/point-of-sale/related-fares/${this.$route.params.id}?${query}`)
                .then(res => {
                    this.items = res.data.data;
                    this.total = res.data.total;
                    this.loading = false;
                });
        },

        getCleanFilter() {
            this.$router.replace({'query': null});
            window.location.reload();
        },
    },

    mounted() {
        if(Object.keys(this.$route.query).length) {
            const {
                sort,
                sortDesc,
                page,
                perPage,
                hotelName,
                roomName,
                fareAmount,
            } = this.$route.query;
            if (sort) {
                this.options.sortBy = sort;
            }
            if (sortDesc) {
                this.options.sortDesc = sortDesc;
            }
            if (page) {
                this.options.page = parseInt(page ? page : 1);
            }
            if (perPage) {
                this.options.perPage = perPage;
            }
            if (hotelName) {
                this.hotelName = hotelName;
            }
            if (roomName) {
                this.roomName = roomName;
            }
            if (fareAmount) {
                this.fareAmount = fareAmount;
            }
        }
    },

    watch: {
        options: {
            handler() {
                this.getData()
            },
            deep: true,
        },
    }
}
</script>

<style lang="scss" scoped>
.col, .col > p{
    margin: 0;
    padding: 0;
}
.row:hover {
    background-color: #DDD;
}
</style>
